/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core";
import { Card, CardMedia, CardContent } from '@material-ui/core'
import SliderDots from "./SliderDots";
import clsx from "clsx";


const useStyles = makeStyles((theme) => ({
  sliderContainer: {
     display: "flex",
     flexDirection: "column",
     alignItems: "center",
     marginTop: '4rem',
     '@media screen and (max-height: 745px)': {
       marginTop: '1rem',
    },
  },
  cardContainer: {
    display: "flex",
    minHeight: "359px",
    minWidth: "259px",
    position: "relative",
    // Turns on 3D animation for cards
    // perspective: "2000px",
    transformStyle: "preserve-3d",
  },
  card: {
      cursor: "pointer",
      opacity: 0,
      position: "absolute",
      height: "359px",
      overflow: "hidden",
      transition: "all 0.5s ease-in-out",
      "&$active": {
         opacity: 1,
         transform: "translate3d(0,0,0)",
         filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))"
      },
      "&$p2": {
         opacity: 1,
         transform: "translate3d(115%,0,-300px)",
         filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))"
      },
      "&$p1": {
         opacity: 1,
         transform: "translate3d(-110%,0,-200px)",
         filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))"
      },
      "&$p1With2Cards": {
         opacity: 1,
         transform: "translate3d(110%,0,-200px)",
         filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))"
      },
      "&$n1": {
         opacity: 1,
         transform: "translate3d(110%,0,-200px)",
         filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))"
      },
      "&$n2": {
         opacity: 1,
         transform: "translate3d(-115%,0,-300px)",
         filter: "drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.1))"
      }
  },
  media: {
    minHeight: '186px',
    minWidth: '232px',
    paddingTop: "56.25%", // 16:9
    margin: '0.5rem',
  },
  cardContent: {
    backgroundColor: "rgba(255, 255, 255, 0.7)",
    textAlign: 'center'
  },
  slideCounter: {
   marginTop: '2rem'
  },
  cardTitle: {
   fontFamily: 'Playfair Display',
   fontStyle: 'normal',
   fontWeight: 700,
   fontSize: '20px',
   lineHeight: '27px',
   textAlign: 'center',
   color: theme.palette.common.black,
   margin: '0px',
  },
  cardDescription: {
   fontFamily: 'Lato',
   fontStyle: 'normal',
   fontWeight: 400,
   fontSize: '14px',
   lineHeight: '17px',
   textAlign: 'center',
   color: theme.palette.common.black,
  },
  selfCenter: {
   alignSelf: 'center'
  },
  active: {},
  p1: {},
  p1With2Cards: {},
  p2: {},
  n1: {},
  n2: {},
}));

const Slider = () => {
  const classes = useStyles();
  const [currentCardIndex, setCurrentCardIndex] = useState(0);
  const [p1, setP1] = useState();
  const [p2, setP2] = useState();
  const [n1, setN1] = useState();
  const [n2, setN2] = useState();

  const cards = [
    {
      title: "Roses",
      description:
        "Radiant. Timeless. Romantic. There’s something special about roses.",
      imageUrl: "https://picsum.photos/600/400?random=1"
    },
    {
      title: "Roses",
      description:
        "Radiant. Timeless. Romantic. There’s something special about roses.",
      imageUrl: "https://picsum.photos/600/400?random=2"
    },
    {
      title: "Roses",
      description:
        "Radiant. Timeless. Romantic. There’s something special about roses.",
      imageUrl: "https://picsum.photos/600/400?random=3"
    },
   //  {
   //    title: "Roses",
   //    description:
   //      "Radiant. Timeless. Romantic. There’s something special about roses.",
   //    imageUrl: "https://picsum.photos/600/400?random=4",
   //  },
   //  {
   //    title: "Roses",
   //    description:
   //       "Radiant. Timeless. Romantic. There’s something special about roses.",
   //    imageUrl: "https://picsum.photos/600/400?random=5"
   //  },
  ];

  useEffect(() => {
   const prev = getPrev(currentCardIndex);
   const next = getNext(currentCardIndex);
   setP1(prev);
   setP2(getPrev(prev));
   setN1(next);
   setN2(getNext(next));
 }, [currentCardIndex]);

  const getNext = (index) => (index + 1) % cards.length;
  const getPrev = (index) => (index - 1 + cards.length) % cards.length;

 const indexToClassName = (index) => {
   if (index === currentCardIndex) return clsx(classes.card, classes.active);
   if (index === p1 && cards.length === 2) return clsx(classes.card, classes.p1With2Cards);
   if (index === p1) return clsx(classes.card, classes.p1);
   if (index === p2) return clsx(classes.card, classes.p2);
   if (index === n1) return clsx(classes.card, classes.n1);
   if (index === n2) return clsx(classes.card, classes.n2);
   return classes.card;
 };

  return (
   <React.Fragment>
    <div className={`${classes.sliderContainer} ${cards.length === 2 ? classes.selfCenter : ''}`}>
      <div className={classes.cardContainer}>
        {cards.map((card, index) => (
          <Card
            key={index}
            className={indexToClassName(index)}
            onClick={() => setCurrentCardIndex(index)}
            onWheel={() => setCurrentCardIndex(getNext(index))}
            onTouchStart={() => setCurrentCardIndex(index)}
          >
            <CardMedia
              className={classes.media}
              image={card.imageUrl}
              title={card.title}
            />
            <CardContent className={classes.cardContent}>
              <p className={classes.cardTitle}>
                {card.title}
              </p>
              <p className={classes.cardDescription}>
                {card.description}
              </p>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
    <SliderDots cards={cards} currentCardIndex={currentCardIndex} setCurrentCardIndex={setCurrentCardIndex} />
   </React.Fragment>
  );
};

export default Slider;
